// release-mode-chip.ts — the quiet BASIC marker on a release row (Basic Helm,
// parent #6484, owner follow-up 2026-10-09). The owner, testing basic on qa:
// in the releases grid a BASIC release looked the same as a full one.
//
// The data was already there: GET /api/releases puts `mode` on every row
// (server release-mode.ts rowMode; a row with no frozen mode reads `full`, an
// unreadable one the NAMED `invalid`). This file only DECIDES the chip; home.ts
// paints it beside the name with the chip primitive (mkChip) — a chip, never a
// button. MODE-GATED: only `basic` returns a model, so a full row (and an older
// console that sends no mode) paints exactly what it painted before.
//
// Pure, so scripts/basic-mode-marker.test.mjs drives it directly.

import { BASIC_CREATE_LINE } from './create-mode.js';

export interface ReleaseModeChip {
  /** The chip's word. */
  label: string;
  /** The hover (data-tip) and the accessible name's tail. */
  tip: string;
}

/** The chip for a release row, or null (paint nothing). */
export function releaseModeChipModel(row: { mode?: unknown } | null | undefined): ReleaseModeChip | null {
  if (row?.mode !== 'basic') return null;
  return { label: 'Basic', tip: BASIC_CREATE_LINE };
}
